const { createContext, useState, useContext } = require("react")

const ModalContext = createContext()

const ModalProvider = ({ children }) => {
    const [modal, setModal] = useState({ show: false, title: '', message: '', showReject: false, rejectReasons: [], content: null, leftButton: undefined, rightButton: undefined, leftButtonAction: () => { }, rightButtonAction: () => { } })
    const [imageModal, setImageModal] = useState({ show: false, title: null, link: null, zoomable: false })

    const hideModal = () => {
        setModal({ show: false, title: '', message: '', showReject: false, rejectReasons: [], content: null, leftButton: undefined, rightButton: undefined, leftButtonAction: () => { }, rightButtonAction: () => { } })
    }

    const showModal = ({ title, message, content = null, leftButton, leftButtonAction, rightButton, rightButtonAction, showReject, rejectReasons }) => {
        setModal({
            show: true,
            title,
            message,
            showReject,
            rejectReasons,
            content,
            leftButton,
            rightButton,
            leftButtonAction: leftButtonAction || (() => { hideModal() }),
            rightButtonAction: rightButtonAction || (() => { hideModal() })
        })
    }

    const showImage = ({ title, link, zoomable }) => {
        setImageModal({
            show: true,
            title,
            link,
            zoomable,
        })
    }
    const hideImage = () => {
        setImageModal({ show: false, title: null, link: null })
    }

    return (
        <ModalContext.Provider value={{
            modal,
            imageModal,
            hideModal,
            showModal,
            showImage,
            hideImage,
        }}>
            {children}
        </ModalContext.Provider>
    )
}

const useModal = () => {
    const { modal, hideModal, showModal, imageModal, showImage, hideImage } = useContext(ModalContext)

    return {
        modal, hideModal, showModal, imageModal, showImage, hideImage
    }
}

export { ModalProvider, useModal }